import { Endpoint } from '@/types/api.type.ts';

export const modelEndpoints: Endpoint[] = [
    {
        name: 'getModels',
        method: 'get',
        path: '/models',
    },
    {
        name: 'getModel',
        method: 'get',
        path: '/models/:id',
    },
    {
        name: 'createModel',
        method: 'post',
        path: '/models',
    },
    {
        name: 'updateModel',
        method: 'patch',
        path: '/models/:id',
    },
    {
        name: 'activateModel',
        method: 'patch',
        path: '/models/activate-model/:id',
    },
    {
        name: 'deactivateModel',
        method: 'patch',
        path: '/models/deactivate-model/:id',
    },
    {
        name: 'getAllActiveModels',
        method: 'get',
        path: '/models/all-active',
    },
    {
        name: 'getModelsDeliveryPricesStatuses',
        method: 'get',
        path: '/models/delivery-price-exist',
    },
];
